export const roundToTwoDecimalPlaces = (value: number): number | null => {
  if (typeof value !== 'number' || isNaN(value)) {
    // eslint-disable-next-line no-console
    console.error(
      'Не удалось округлить число, т.к. оно не является числом:',
      value
    );
    return null;
  }

  return Math.round(value * 100) / 100;
};
